<div class="toast" data-testid="toast" [attr.data-type]="type()">
  <span class="toast-icon" [style.color]="iconConfig().color">{{ iconConfig().icon }}</span>
  <span class="toast-message" [innerHTML]="message()"></span>
  <button class="toast-close" type="button" [attr.aria-label]="closeAriaLabel() || null" (click)="closed.emit()">&times;</button>
</div>
